import React, { Component } from "react";
import * as _ from "lodash-es";
import ContextEnum from "../../../models/ContextEnum";
import "./OwChips.scss";
import ChipSizeEnum from "./ChipSizeEnum";

type Props = {
    chips?: string | string[];
    updatedFn: (chips: string | string[]) => void;
    context?: ContextEnum;
    chipSize?: ChipSizeEnum;
    isPill?: boolean;
    isStacked?: boolean;
};

type State = {
    chips: string[];
};

class OwChips extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        const chips = this.setupChips();

        this.state = {
            chips,
        };
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps.chips?.length !== this.props.chips?.length) {
            const chips = this.setupChips();

            this.setState({
                chips,
            });
        }
    }

    setupChips = (): string[] => {
        let chips = this.props.chips || [];

        if (_.isString(chips)) {
            chips = chips.split(",");

            for (let chip of chips) {
                chip = chip.trim();
            }
        }

        return chips;
    };

    updatedFn = () => {
        if (_.isString(this.props.chips)) {
            this.props.updatedFn(this.state.chips.join(","));
        } else {
            this.props.updatedFn(this.state.chips);
        }
    };

    removeChip = (chip: string, index: number) => {
        console.log("removeChip", chip, index);
        const chips = this.state.chips;

        chips.splice(index, 1);

        this.setState(
            {
                chips,
            },
            () => {
                this.updatedFn();
            }
        );
    };

    render() {
        let context = "";

        if (this.props.context) {
            context = `bg-${this.props.context}`;
        }

        let pillContext = "";

        if (this.props.isPill) {
            pillContext = "badge-pill";
        }

        let flexType = "d-inline-flex";

        if (this.props.isStacked) {
            flexType = "";
        }

        let ChipTag: any = "div";

        if (this.props.chipSize) {
            ChipTag = this.props.chipSize;
        }

        return (
            <div className="OwChips">
                {this.state.chips.map((chip, index: number) => {
                    const deleteIcon = (
                        <span
                            className={"pointer"}
                            onClick={(e: any) => {
                                this.removeChip(chip, index);
                            }}>
                            <i className={"fas fa-times-circle"}></i>
                        </span>
                    );

                    return (
                        <ChipTag className={`${flexType}`} key={chip}>
                            <div className={`badge ${context} ${pillContext}`}>
                                {chip} {deleteIcon}
                            </div>
                        </ChipTag>
                    );
                })}
            </div>
        );
    }
}

export default OwChips;
